<template>
    <div style="width: 85%;margin:0 auto;">
        <!-- 吸顶导航（顶部信息条 + 主导航） -->
        <header class="site-header" :class="{ 'scrolled': scrolled }">
            <!-- 顶部信息条 -->
            <div class="topbar">
                <div class="topbar_inner">
                    <span class="topbar_tag">{{ $t('topbar_slogan') }}</span>
                    <span class="topbar_actions">
                        <a class="topbar_link" @click="goConcat">{{ $t('header_menu.contact') }}</a>
                        <a class="topbar_cta" @click="goConcat">{{ $t('get_a_quote') }}</a>
                    </span>
                </div>
            </div>
            <!-- 主导航 -->
            <div class="header_content">
                <div class="header_logo_content">
                    <img loading="lazy" class="header_logo_img" src="@/assets/logo.png" @click="goIndex">
                </div>
                <nav class="nav_menu">
                    <div class="menu_title"
                         :class="{'menu_active': isCheck===index}"
                         :style="{'color':isCheck===index?'var(--brand)':'#000000'}"
                         @click="jump1(item.id)"
                         v-for="(item,index) in menuList" :key="item.id">
                        <span v-if="index!==2">{{ item.name }}</span>
                        <span v-if="index===2" class="multi-level-dropdown">
                            <span class="dropdown-link" @click.stop="btnProduct(1)">{{ item.name }}</span>
                            <div class="dropdown-content">
                                  <div class="dropdown-item" v-for="subItem in typeList" :key="subItem.id">
                                    <span @click.stop="btnProduct(2,subItem.id)">{{ subItem.name }}</span>
                                        <div class="dropdown-content-sub" v-if="subItem.children">
                                              <div @click.stop="btnProduct(3,subSubItem.id,subSubItem)" class="dropdown-item"
                                                   v-for="subSubItem in subItem.children"
                                                   :key="subSubItem.id">
                                                {{ subSubItem.name }}
                                              </div>
                                        </div>
                                  </div>
                            </div>
                        </span>
                    </div>
                </nav>
                <div class="header_lang">
                    <el-dropdown @command="switchLang" placement="bottom-end">
                        <span class="el-dropdown-link">
                            {{ currentLang }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="item in langList" :key="item.name" :command="item">{{ item.name }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </header>

        <!-- 占位：补偿吸顶导航高度 -->
        <div class="header_spacer"></div>

        <!-- 右侧悬浮窗 -->
        <right-tools></right-tools>
    </div>

</template>
<script>
import {getCurrentInstance} from 'vue';
import News from "@/views/news/News.vue";
import RightTools from "@/views/tools/RightTools.vue";
import {reqListProductsType} from "@/api/core/ProductsType";

//语言
const langList = [
    {"name": "中文", "code": "zh-CN"},
    {"name": "English", "code": "en-US"},
    {"name": "Español", "code": "es-ES"},
    {"name": "العربية", "code": "ar-SA"},
    {"name": "Русский", "code": "ru-RU"},
    {"name": "Português", "code": "pt-PT"},
]
export default {
    name: "TopHeader",
    components: {RightTools, News},
    async created() {
        const {proxy} = getCurrentInstance();
        // 初始化当前语言
        const currentLangCode = sessionStorage.getItem("lang") || 'en-US'; // 默认语言
        this.$i18n.locale = currentLangCode; // 设置 i18n 的语言
        this.langList.forEach((lang) => {
            if (lang.code === currentLangCode) {
                this.currentLang = lang.name; // 设置当前语言名称
            }
        });
        await this.loadType();
        this.updateActive(this.$route.path);
    },
    watch: {
        // 监听路由对象$route的变化
        '$route': {
            handler: function (to) {
                this.updateActive(to.path);
            },
            // 设置为深度监听
            deep: true
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, {passive: true});
        this.handleScroll();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // 根据路由高亮对应一级菜单（产品子页 /productsType2、/products 等也能命中"Products"）
        updateActive(path) {
            const map = [
                {idx: 0, test: p => p === '/'},
                {idx: 1, test: p => p.startsWith('/about')},
                {idx: 2, test: p => p.startsWith('/products')},
                {idx: 3, test: p => p.startsWith('/news')},
                {idx: 4, test: p => p.startsWith('/download')},
                {idx: 5, test: p => p.startsWith('/concat')},
            ];
            for (const m of map) {
                if (m.test(path)) {
                    this.isCheck = m.idx;
                    return;
                }
            }
        },
        jump1(index) {
            this.$router.push(this.menuList[index].path);
        },
        goIndex() {
            this.$router.push("/");
        },
        goConcat() {
            this.$router.push("/concat");
        },
        handleScroll() {
            this.scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > 8;
        },
        switchLang(lang) {
            this.currentLang = lang.name;
            this.$i18n.locale = lang.code;
            sessionStorage.setItem("lang", lang.code);
            window.location.reload();
        },
        async loadType() {
            let {data} = await reqListProductsType({});
            this.typeList = data;
        },
        async btnProduct(type, id, item) {
            if (type === 1) {
                this.$router.push({path: '/productsType'});
                return;
            }
            if (type === 2) {
                this.$router.push({path: '/productsType2', query: {pid: id}});
                return;
            }
            //判断是否有下级，如果有则跳转type3，没有则产品列表
            if (type === 3) {
                if (item.children && item.children.length > 0) {
                    //跳转三级类型页面
                    this.$router.push({path: '/productsType3', query: {pid: id}});
                    return
                } else {
                    this.$router.push({path: '/products', query: {type: id}});
                    return;
                }
            }
        }
    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {},
            currentRoute: null,
            menuList: [
                {id: 0, name: this.$t('header_menu.home'), path: "/"},
                {id: 1, name: this.$t('header_menu.about'), path: "/about"},
                {id: 2, name: this.$t('header_menu.product'), path: "/productsType"},
                {id: 3, name: this.$t('header_menu.news'), path: "/news"},
                {id: 4, name: this.$t('header_menu.download'), path: "/download"},
                {id: 5, name: this.$t('header_menu.contact'), path: "/concat"},
            ],
            isCheck: 0,
            scrolled: false,
            langList: langList,
            currentLang: "1",
            typeList: [],
            // 当前悬浮的一级菜单索引
            currentHoverIndex: 0,
        }
    },
}
</script>
<style scoped lang="scss">
$brand: #246543;        // 森林绿主色
$brand-dark: #1b4d33;
$wood: #c08a4e;         // 木色点缀
$text: #2b2b2b;

.content_div {
    background-color: white;
}

.top_title {
    margin-left: 30px;
    cursor: pointer;
}

/* 吸顶整体 */
.site-header {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 85%;
    z-index: 999;
    background: #ffffff;
}

.header_spacer {
    height: 140px;
}

/* 顶部信息条 */
.topbar {
    background: $brand-dark;
    color: #fff;
    overflow: hidden;
    max-height: 40px;
    transition: max-height .3s ease, opacity .3s ease;
}

.topbar_inner {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    letter-spacing: .3px;
    padding-left: 20px;
    padding-right: 20px;
}

.topbar_tag {
    opacity: .82;
}

.topbar_actions {
    display: inline-flex;
    align-items: center;
    gap: 18px;
}

.topbar_link {
    color: #fff;
    opacity: .82;
    cursor: pointer;
    transition: opacity .2s;

    &:hover {
        opacity: 1;
    }
}

.topbar_cta {
    background: $wood;
    color: #fff;
    padding: 4px 14px;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color .2s;

    &:hover {
        background: var(--wood-dark);
    }
}

.scrolled .topbar {
    max-height: 0;
    opacity: 0;
}

/* 主导航 */
.header_content {
    height: 100px;
    display: flex;
    align-items: center;
    background: #fff;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
    border-bottom: 3px solid $brand;
    transition: box-shadow .3s ease;
}

.scrolled .header_content {
    box-shadow: 0 6px 22px rgba(0, 0, 0, 0.12);
}

.header_logo_content {
    width: 30%;
    display: flex;
    align-items: center;
}

.header_logo_img {
    cursor: pointer;
    height: 100px;
    object-fit: contain;
}

.nav_menu {
    width: 55%;
    display: flex;
    justify-content: space-around;
    flex-shrink: 1;
}

/* 一级菜单（工业感大写排版） */
.menu_title {
    font-size: 15px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .6px;
    cursor: pointer;
    position: relative;
    padding: 0 6px;
    color: $text;
    transition: color .25s ease;

    &:hover {
        color: $brand;
    }

    &::after {
        content: '';
        position: absolute;
        left: 6px;
        right: 6px;
        bottom: 30px;
        height: 2px;
        background: $brand;
        border-radius: 2px;
        transform: scaleX(0);
        transform-origin: center;
        transition: transform .25s ease;
    }

    &:hover::after,
    &.menu_active::after {
        transform: scaleX(1);
    }
}

.menu_active {
    color: $brand;
}

.header_lang {
    width: 15%;
    text-align: right;
    flex-shrink: 0;
}

/* 语言切换（胶囊样式） */
.el-dropdown-link {
    cursor: pointer;
    color: $brand;
    font-weight: 600;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 14px;
    border: 1px solid rgba(36, 101, 67, 0.25);
    border-radius: 20px;
    transition: background-color .2s, border-color .2s;

    &:hover {
        background-color: rgba(36, 101, 67, 0.08);
        border-color: $brand;
    }
}

.el-icon-arrow-down {
    font-size: 12px;
}

/* 多级导航（产品） */
.multi-level-dropdown {
    position: relative;
}

.dropdown-link {
    display: inline-block;
    cursor: pointer;
}

.dropdown-content {
    position: absolute;
    top: 64px;
    left: 50%;
    transform: translateX(-50%) translateY(10px);
    background-color: #ffffff;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
    border-radius: 8px;
    border-top: 3px solid $brand;
    z-index: 1000;
    line-height: 48px;
    width: 280px;
    padding: 8px 0;
    opacity: 0;
    visibility: hidden;
    transition: opacity .25s ease, transform .25s ease, visibility .25s;
}

.multi-level-dropdown:hover .dropdown-content {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
}

.dropdown-content-sub {
    position: absolute;
    top: 0;
    left: 100%;
    background-color: #ffffff;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
    border-radius: 8px;
    z-index: 1000;
    width: 280px;
    line-height: 48px;
    padding: 8px 0;
    opacity: 0;
    visibility: hidden;
    transition: opacity .25s ease, visibility .25s;
}

.dropdown-item:hover .dropdown-content-sub {
    opacity: 1;
    visibility: visible;
}

.dropdown-item {
    cursor: pointer;
    font-weight: 500;
    padding: 0 20px;
    position: relative;
    color: $text;
    white-space: nowrap;
    transition: color .2s ease, background-color .2s ease;

    &:hover {
        background-color: rgba(36, 101, 67, 0.08);
        color: $brand;
    }
}
</style>
